export default "__VITE_ASSET__Drn4jRnH__"